import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, parseError } from "./api";
import { useAuth } from "./auth";

export function useMembers() {
  const { me } = useAuth();
  const [list, setList] = useState([]);
  const ws = me?.user?.active_workspace_id;
  useEffect(() => { if (ws) api.get(`/workspaces/${ws}/members`).then((r) => setList((r.data.members || r.data).filter((m) => m.status === "active"))).catch(() => {}); }, [ws]);
  return list;
}

export const apiMessage = (t, e) => {
  const x = parseError(e);
  if (x.missing) return x.missing.map((m) => t(`miss.${x.code}.${m}`, { defaultValue: t(`p2.missing.${m}`, { defaultValue: t(`activation.${m}`, { defaultValue: t("miss.generic") }) }) })).join(" · ");
  if (x.errors) return x.errors.map((er) => `${t(`p2.${er.field.split(".").pop()}`, { defaultValue: er.field })}: ${t(`err.${er.code}`, { defaultValue: t("err.invalid") })}`).join(" · ");
  return t(`err.${x.code}`, { defaultValue: t("err.unknown") });
};

export const apiFail = (t) => (e) => { toast.error(apiMessage(t, e)); };

export async function downloadPdf(path, name) {
  const r = await api.get(path, { responseType: "blob" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(r.data);
  a.download = name;
  a.click();
}
